module.exports = __webpack_public_path__ + "img/lmg.m249.af199314.png";